export default __webpack_public_path__ + "static/media/company.df9b68c2.svg";